<template>
  <transition name="error-alert">
    <div class="container">
      <FontAwesomeIcon
        :icon="faTimesCircleSolid"
        class="close-button"
        @click="$emit('close-alert')"
      />
      <FontAwesomeIcon :icon="faTimesCircle" size="3x" class="error-icon" />
      <p class="error-message">
        <span class="error-message--title">Oops...</span>
        <br />
        <span>Something went wrong, please try again!</span>
      </p>
    </div>
  </transition>
</template>

<script>
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { faTimesCircle as faTimesCircleSolid } from "@fortawesome/free-solid-svg-icons";

export default {
  data() {
    return {
      faTimesCircle,
      faTimesCircleSolid,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";
@import "../scss/common.scss";
@import "../scss/animations.scss";

.container {
  background: $sexternary-lighter;
  position: absolute;
  //top: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  padding: 2rem 1rem;
}

.close-button {
  position: absolute;
  right: 1rem;
  top: 1rem;

  color: #e9dfb2;
  background: $darker-grey;
  border-radius: 50%;
}

.error-icon {
  color: $darker-grey;
}

.error-message {
  font-family: $primary-font;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: $darker-grey;
  margin-left: 1rem;
}

.error-message--title {
  font-weight: 800;
}
</style>
